import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { TrainingConfirmationModel } from "../models/training-confirmation.model";
import { ConfirmationResultModel } from "../models/confirmation-result.model";

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {

    private httpClient: HttpClient;
    
    constructor(private httpBackend: HttpBackend) {
        this.httpClient = new HttpClient(httpBackend);
    }

    public confirmTrainingParticipation(trainingKey: string, trainingConfirmationModel: TrainingConfirmationModel): Observable<ConfirmationResultModel> {
        return this.httpClient.post<ConfirmationResultModel>(
            Configuration.getApiBaseUrl() + "/confirmation/" + trainingKey + "/confirm", 
            trainingConfirmationModel
        );
    }
}